import React from 'react'
import './index.css'

function PostBlock({ doc, children }) {

    let title = doc.title
    let created_at = doc.date
    let tags = doc.tags

    // let isIpynb = title.match(/.*\.ipynb/) === null ? false : true
    // let ownerName = post.owner.login
    return (
        <div key={title} id="Post-Block" className='pt-3 pb-3'>
            <div className="post-header">
                <div className="text-center">
                    <div className="post-title-row">
                        <a className='post-title' href={doc.page_link}>{title}</a>
                    </div>

                    <div className="post-summary-meta">
                        <small>
                            #{tags.join(" #")} · <span className='post-date'>{created_at}</span>
                            <br />
                        </small>
                    </div>
                </div>
                <hr />
            </div>
            {children}
        </div>
    )
}

export default PostBlock
